import React from 'react';
import LocationTemplate from './LocationTemplate';

const WilliamstonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Williamston"
      stateName="North Carolina"
      countyName="Martin"
      zipCodes={["27892"]}
      latitude={35.8546}
      longitude={-77.056}
      population={5119}
      historicalFact="Established in 1779, named after William Williams who donated land for the town."
      nearbyTowns={[
        "Washington, NC",
        "Plymouth, NC",
        "Greenville, NC",
        "Rocky Mount, NC",
        "Robersonville, NC",
        "Hamilton, NC",
        "Oak City, NC",
        "Jamesville, NC"
      ]}
    />
  );
};

export default WilliamstonPage;